export default __webpack_public_path__ + "static/media/Piccolo_giardiniere.f5f5a415.jpg";